import type { Action } from 'react-sweet-state';
import { createStore, createActionsHook, createStateHook } from 'react-sweet-state';

type OnboardingTrackerState = {
	expandedTrackerItem: string | null;
	isTrackerPopupOpen: boolean;
	isMemorizedTrackerPopupMinimized: boolean;
};

const initialState: OnboardingTrackerState = {
	expandedTrackerItem: null,
	isTrackerPopupOpen: true,
	isMemorizedTrackerPopupMinimized: false,
};

const actions = {
	setExpandedTrackerItem:
		(item: string | null): Action<OnboardingTrackerState> =>
		({ setState }) => {
			setState({
				expandedTrackerItem: item,
			});
		},
	setIsTrackerPopupOpen:
		(value: boolean): Action<OnboardingTrackerState> =>
		({ setState }) => {
			setState({
				isTrackerPopupOpen: value,
			});
		},
	setIsMemorizedTrackerPopupMinimized:
		(value: boolean): Action<OnboardingTrackerState> =>
		({ setState }) => {
			setState({
				isMemorizedTrackerPopupMinimized: value,
			});
		},
};

const OnboardingTrackerStore = createStore({
	initialState,
	actions,
	name: 'OnboardingTrackerStore',
});

export const useOnboardingTrackerStoreState = createStateHook(OnboardingTrackerStore);
export const useOnboardingTrackerStoreActions = createActionsHook(OnboardingTrackerStore);
